// extracted by mini-css-extract-plugin
export default {"-large":"NEaLsrrDuA8LZYnUFWdl","setHoveredStyle":"mMSeJxeUTJSnVRrew30K","setBorder":"BaDQ8oGuuhIXKZuFlvCV","clickedStyleBg":"qjV4HFIPVhfQPvkNLjvd"};